export default __webpack_public_path__ + "static/media/326.769203cc.png";